import PropTypes from 'prop-types';

const propType = {
  week: PropTypes.arrayOf(
    PropTypes.shape({ points: PropTypes.number.isRequired }),
  ).isRequired,
  month: PropTypes.arrayOf(
    PropTypes.shape({ points: PropTypes.number.isRequired }),
  ).isRequired,
  meMonth: PropTypes.arrayOf(
    PropTypes.shape({ points: PropTypes.number.isRequired }),
  ).isRequired,
  hardSkills: PropTypes.arrayOf(
    PropTypes.shape({
      total: PropTypes.number.isRequired,
      level: PropTypes.number.isRequired,
      hardSkills: PropTypes.shape({ name: PropTypes.string.isRequired })
        .isRequired,
    }),
  ).isRequired,
};

export default { propType };
